import { api } from "@/api"

type RetrieveMerchantGroupUserResponse = {
  id: string
  email: string
  firstName: string
  lastName: string
  isActive: boolean
}

export const retrieveMerchantGroupUser = async (
  userId: string
) => {
  const { body } =
    await api.get<RetrieveMerchantGroupUserResponse>(
      `/merchant-group/users/${userId}/`,
      { isMerchantGroup: true }
    )

  return body
}
